module.exports = __webpack_public_path__ + "static/image_1-75fbd4e178221a4bb46010dd4de3a012.jpg";